import { GetStaticProps, InferGetStaticPropsType, NextPage } from 'next';

import {
  FooterDocument,
  FooterQuery,
  FooterQueryVariables,
  LegalNoticeDocument,
  LegalNoticeQuery,
  LegalNoticeQueryVariables,
  NavigationDocument,
  NavigationQuery,
  NavigationQueryVariables,
} from '@/api';
import { addApolloState, initializeApollo } from '@/api/apolloClient';
import { Layout } from '@/components/layout/Layout';
import { Seo } from '@/components/Seo';
import EnhancedPolicyPageWrapper from '@/components/shared/EnhancedPolicyPageWrapper';

export const getStaticProps: GetStaticProps = async () => {
  const client = initializeApollo();

  // prefetch
  await client.query({ query: NavigationDocument });
  await client.query({ query: LegalNoticeDocument });
  await client.query({ query: FooterDocument });

  const { data: footerData } = await client.query<
    FooterQuery,
    FooterQueryVariables
  >({ query: FooterDocument });

  const { data: headerData } = await client.query<
    NavigationQuery,
    NavigationQueryVariables
  >({ query: NavigationDocument });

  const { data: legalNotice } = await client.query<
    LegalNoticeQuery,
    LegalNoticeQueryVariables
  >({
    query: LegalNoticeDocument,
  });
  return addApolloState(client, {
    props: {
      legalNotice,
      footerData,
      headerData,
    },
  });
};

export type TableRowType = string[];

export type BulletType = {
  text: string;
  isIndented: boolean;
};

const LegalNotice: NextPage<InferGetStaticPropsType<typeof getStaticProps>> = ({
  footerData,
  headerData,
  legalNotice,
}) => (
  <Layout footerData={footerData} headerData={headerData} invertedColor>
    <Seo seo={legalNotice?.legalNotice?.data?.attributes?.seo} />
    <EnhancedPolicyPageWrapper
      data={legalNotice?.legalNotice?.data?.attributes?.legalNotice}
    />
  </Layout>
);

export default LegalNotice;
